import type { ReactNode } from 'react';
import { createPortal } from 'react-dom';
import { Platform } from 'react-native';

interface WebPortalProps {
  children: ReactNode;
}

/**
 * WebPortal renders children at the document.body level on web.
 * This ensures the content appears above all other elements including modals.
 *
 * On non-web platforms, this component simply renders children directly.
 */
const WebPortal = ({ children }: WebPortalProps) => {
  // Only use createPortal on web
  if (Platform.OS !== 'web') {
    return <>{children}</>;
  }

  // Render at document.body to ensure highest stacking context
  if (typeof document !== 'undefined') {
    return createPortal(children, document.body);
  }

  return <>{children}</>;
};

WebPortal.displayName = 'WebPortal';

export { WebPortal };
